import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_3 = { class: "p-5 d-flex justify-content-center flex-column" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "d-flex flex-row justify-content-center gap-10 pt-10" }
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_7 = { class: "p-5 d-flex flex-row justify-content-between" }
const _hoisted_8 = { class: "fs-3x bolder" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-times" })
], -1)
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "ps-5 mb-5" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Choose Bundle Deals & Get Additional Entries")
], -1)
const _hoisted_12 = { class: "d-flex justify-content-center" }
const _hoisted_13 = {
  key: 1,
  class: "mt-20"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h1", null, "No bundles available for this draw", -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_TabLoader = _resolveComponent("TabLoader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PlanBundleTabsView = _resolveComponent("PlanBundleTabsView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_skeleton, {
                rows: 2,
                animated: ""
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createVNode(_component_TabLoader, {
                  loading: _ctx.loading,
                  width: `300px`,
                  height: `300px`
                }, null, 8, ["loading"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_TabLoader, {
                  loading: _ctx.loading,
                  width: `300px`,
                  height: `300px`
                }, null, 8, ["loading"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_TabLoader, {
                  loading: _ctx.loading,
                  width: `300px`,
                  height: `300px`
                }, null, 8, ["loading"])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.draw.title), 1),
            _createVNode(_component_router_link, {
              to: "/dashboard",
              class: "fs-4 bolder"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              (_ctx.bundles.length)
                ? (_openBlock(), _createBlock(_component_PlanBundleTabsView, {
                    key: 0,
                    bundles: _ctx.bundles
                  }, null, 8, ["bundles"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
            ])
          ])
        ]))
  ]))
}